import React from "react";
import { Link as GatsbyLink } from "gatsby-link";
import { NavLink } from "theme-ui";
import { KameleonLinkProps } from "./types";

export const Link: React.FC<KameleonLinkProps> = ({
  children,
  to,
  activeClassName,
  partiallyActive,
  className,
}) => {
  const internal = /^\/(?!\/)/.test(to);

  const linkProps = internal
    ? {
        as: GatsbyLink,
        to,
        activeClassName,
        partiallyActive,
        className,
      }
    : {
        href: to,
        className,
      };

  return <NavLink {...linkProps}>{children}</NavLink>;
};
